<template>
  <v-container id="gallery" tag="section">
    <base-subheading>
      Gallery
      <v-chip
        class="hidden-sm-and-down"
        color="primary"
        small
        @click="viewAllPictures"
        >View All Pictures</v-chip
      >
    </base-subheading>
    <GalleryCategories></GalleryCategories>
    <v-btn
      block
      class="mt-1 hidden-md-and-up"
      color="primary"
      @click="viewAllPictures"
      >View All Pictures</v-btn
    >
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Gallery",
  components: {
    GalleryCategories: () => import("../components/gallery/GalleryCategories"),
  },
  computed: {
    ...mapGetters(["facebookUrl", "instagramUrl"]),
  },
  methods: {
    viewAllPictures() {
      window.open(this.instagramUrl, "_blank").focus();
    },
  },
};
</script>
